import { useLanguage } from '../contexts/LanguageContext';

export function HeroSection() {
  const { t } = useLanguage();

  return (
    <div className="hero-section">
      <div className="badge">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
        </svg>
        {t.hero.badge}
      </div>
      
      <h1>{t.hero.title}</h1>
      
      <p className="subtitle">
        {t.hero.subtitle}
      </p>
      
      <p className="description">
        {t.hero.description}
      </p>
    </div>
  );
}
